import { createContext } from "react";

const ProductDetailsContext = createContext();

export default ProductDetailsContext;
